import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import Product from "../Product/Product";
const Products = () => {
  const [homeProducts, setHomeProducts] = useState([]);
  useEffect(() => {
    fetch("https://carame-cake-server-site.vercel.app/homeProducts")
      .then((res) => res.json())
      .then((data) => setHomeProducts(data));
  }, []);
  return (
    <div className="container-fluid">
      <h3 className="text-center mt-5">New Product</h3>
      <Row lg={4}>
        {homeProducts.map((homeProduct) => (
          <Product key={homeProduct._id} homeProduct={homeProduct}></Product>
        ))}
      </Row>
    </div>
  );
};

export default Products;
